module.exports = __webpack_public_path__ + "img/chalalit_no.b94fe0b4.png";